import { render, staticRenderFns } from "./ChangeVesselForm.vue?vue&type=template&id=659524a2"
import script from "./ChangeVesselForm.vue?vue&type=script&lang=js"
export * from "./ChangeVesselForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports